import * as api from '@owl-nest/api-client/latest'
import * as i18n from './i18n'

export type Impact = Omit<api.Impact, 'sdgs'> & {
  sdgs: (Omit<api.ProjectSDG, 'id'> & { id: number | undefined; deleted?: boolean; touched?: boolean })[]
}

export function model(impact: api.Impact): Impact {
  return {
    ...impact,
    sdgs: impact.sdgs ?? [],
  }
}

export function getCertifications(impact: Impact, lang: api.Lang): string {
  return i18n.get(impact.certifications, lang, '')
}

export function getChallenges(impact: Impact, lang: api.Lang): string {
  return i18n.get(impact.challenges, lang, '')
}

export function getImpact(impact: Impact, lang: api.Lang): string {
  return i18n.get(impact.impact, lang, '')
}

export function isEmpty(impact: Impact): boolean {
  return (
    (Object.keys(impact.impact).length === 0 || Object.values(impact.impact).every((value) => !value)) &&
    (Object.keys(impact.certifications).length === 0 || Object.values(impact.certifications).some((value) => !value)) &&
    impact.sdgs.length === 0
  )
}

export function getLangs(impact: Impact | api.Impact): api.Lang[] {
  const langs = new Set([
    ...i18n.getLangs(impact.certifications),
    ...i18n.getLangs(impact.challenges),
    ...i18n.getLangs(impact.impact),
  ])

  if (impact.sdgs) {
    for (const sdg of impact.sdgs) {
      i18n.getLangs(sdg.description).forEach((lang) => langs.add(lang))
    }
  }

  return Array.from(langs.keys())
}
